import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal as WaxModal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, useBreakpointValue, } from '@noom/wax-component-library';
import useElement from '../../../core/hooks/useElement';
const Modal = ({ size, isCentered, className, onOverlayClick, onCancel, title, footer, isOpen, children, scrollBehavior, 'data-qa-anchor': dataQaAnchor = '', }) => {
    const [modalRef, modalElement] = useElement();
    // auto focus to prevent scroll on background (when focus kept on trigger button)
    useEffect(() => modalElement && modalElement.focus(), [modalElement]);
    const forceCentered = useBreakpointValue({
        base: false,
        md: true,
    });
    const attrProps = { className, ref: modalRef };
    const modalSize = size === 'small' ? 'sm' : 'lg';
    return (React.createElement(WaxModal, { isOpen: isOpen, isCentered: isCentered || forceCentered, onClose: onCancel !== null && onCancel !== void 0 ? onCancel : onOverlayClick, size: modalSize, scrollBehavior: scrollBehavior },
        React.createElement(ModalOverlay, null),
        React.createElement(ModalContent, Object.assign({ tabIndex: 0, marginY: 0 }, attrProps, { "data-qa-anchor": dataQaAnchor }),
            title && React.createElement(ModalHeader, null, title),
            onCancel && React.createElement(ModalCloseButton, null),
            React.createElement(ModalBody, null, children),
            footer && React.createElement(ModalFooter, null, footer))));
};
Modal.propTypes = {
    size: PropTypes.string,
    isCentered: PropTypes.bool,
    className: PropTypes.string,
    onOverlayClick: PropTypes.bool,
    onCancel: PropTypes.func,
    title: PropTypes.string,
    footer: PropTypes.any,
    isOpen: PropTypes.bool,
    children: PropTypes.any,
    scrollBehavior: PropTypes.string,
    'data-qa-anchor': PropTypes.string,
};
export default Modal;
//# sourceMappingURL=index.js.map